const SvgAIandMl1 = (props) => (
  <>
    <circle cx={48} cy={48} r={1} fill="#001d6c" />
    <circle cx={64} cy={48} r={1} fill="#001d6c" />
    <circle cx={80} cy={48} r={1} fill="#001d6c" />
    <circle cx={96} cy={48} r={1} fill="#001d6c" />
    <circle cx={112} cy={48} r={1} fill="#001d6c" />
    <circle cx={128} cy={48} r={1} fill="#001d6c" />
    <circle cx={144} cy={48} r={1} fill="#001d6c" />
    <circle cx={48} cy={64} r={1} fill="#001d6c" />
    <circle cx={64} cy={64} r={1} fill="#001d6c" />
    <circle cx={80} cy={64} r={1} fill="#001d6c" />
    <circle cx={96} cy={64} r={1} fill="#001d6c" />
    <circle cx={112} cy={64} r={1} fill="#001d6c" />
    <circle cx={128} cy={64} r={1} fill="#001d6c" />
    <circle cx={144} cy={64} r={1} fill="#001d6c" />
    <circle cx={48} cy={80} r={1} fill="#001d6c" />
    <circle cx={64} cy={80} r={1} fill="#001d6c" />
    <circle cx={80} cy={80} r={1} fill="#001d6c" />
    <circle cx={96} cy={80} r={1} fill="#001d6c" />
    <circle cx={112} cy={80} r={1} fill="#001d6c" />
    <circle cx={128} cy={80} r={1} fill="#001d6c" />
    <circle cx={144} cy={80} r={1} fill="#001d6c" />
    <circle cx={48} cy={96} r={1} fill="#001d6c" />
    <circle cx={64} cy={96} r={1} fill="#001d6c" />
    <circle cx={80} cy={96} r={1} fill="#001d6c" />
    <circle cx={96} cy={96} r={1} fill="#001d6c" />
    <circle cx={112} cy={96} r={1} fill="#001d6c" />
    <circle cx={128} cy={96} r={1} fill="#001d6c" />
    <circle cx={144} cy={96} r={1} fill="#001d6c" />
    <circle cx={48} cy={112} r={1} fill="#001d6c" />
    <circle cx={64} cy={112} r={1} fill="#001d6c" />
    <circle cx={80} cy={112} r={1} fill="#001d6c" />
    <circle cx={96} cy={112} r={1} fill="#001d6c" />
    <circle cx={112} cy={112} r={1} fill="#001d6c" />
    <circle cx={128} cy={112} r={1} fill="#001d6c" />
    <circle cx={144} cy={112} r={1} fill="#001d6c" />
    <circle cx={48} cy={128} r={1} fill="#001d6c" />
    <circle cx={64} cy={128} r={1} fill="#001d6c" />
    <circle cx={80} cy={128} r={1} fill="#001d6c" />
    <circle cx={96} cy={128} r={1} fill="#001d6c" />
    <circle cx={112} cy={128} r={1} fill="#001d6c" />
    <circle cx={128} cy={128} r={1} fill="#001d6c" />
    <circle cx={144} cy={128} r={1} fill="#001d6c" />
    <circle cx={48} cy={144} r={1} fill="#001d6c" />
    <circle cx={64} cy={144} r={1} fill="#001d6c" />
    <circle cx={80} cy={144} r={1} fill="#001d6c" />
    <circle cx={96} cy={144} r={1} fill="#001d6c" />
    <circle cx={112} cy={144} r={1} fill="#001d6c" />
    <circle cx={128} cy={144} r={1} fill="#001d6c" />
    <circle cx={144} cy={144} r={1} fill="#001d6c" />
    <path d="M0 0v192h192V0H0Zm160 160H32V32h128v128Z" fill={props.p20} />
  </>
);

export default SvgAIandMl1;
